<script lang="ts">
  import { onMount } from 'svelte';
  import { api, unwrap } from '../lib/api';
  import type { PublicPromotion } from '@/shared/promotions';

  let promotions = $state<PublicPromotion[]>([]);

  onMount(async () => {
    try {
      promotions = await unwrap<PublicPromotion[]>(await api.api.v1.promotions.$get());
    } catch {
      promotions = [];
    }
  });
</script>

{#if promotions.length > 0}
  <aside class="promotion-ribbon" aria-label="Current promotions">
    <div class="container d-flex flex-wrap justify-content-center gap-2 py-2">
      {#each promotions as promotion (promotion.id)}
        <div class="promotion-pill">
          <strong>{promotion.badgeTitle}</strong>
          <span>{promotion.badgeText}</span>
          {#if promotion.couponRequired}<small>Coupon required at checkout</small>{/if}
        </div>
      {/each}
    </div>
  </aside>
{/if}

<style>
  .promotion-ribbon { background:#fff2df; border-bottom:1px solid #f1dfc5; }
  .promotion-pill { display:flex; flex-wrap:wrap; align-items:center; justify-content:center; gap:.25rem .65rem; text-align:center; color:#594c3a; font-size:.88rem; }
  .promotion-pill strong { color:#70400e; font-weight:900; }
  .promotion-pill small { border-radius:999px; background:#fff; padding:.1rem .5rem; font-size:.7rem; font-weight:800; text-transform:uppercase; letter-spacing:.035em; }
</style>
